import { SEARCH_TYPES } from './searchTypes';

export default (t, collection) =>
  collection
    .groupBy((dataObject) => dataObject.type())
    .map(({ id: type, collection: groupedCollection }) => {
      const config = SEARCH_TYPES[type];

      return {
        groupKey: config.tabKey,
        title: t(config.titleKey),
        icon: config.icon,
        items: groupedCollection.toArray().map((dataObject) => config.optionBuilder(dataObject, t)),
      };
    });
